module.exports = __webpack_public_path__ + "img/la_media_cancha.6818e6b5.jpeg";